// @flow

export default class State {
  id: string;
  name: string;
  location: Array<number>;

  constructor(data: any = {}) {
    this.id = data.id;
    this.name = data.name;
    this.location = data.location;
  }
}
